import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { Check } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import { listItemCheck } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuRadioItemIndicatorProps extends PartProps<BaseContextMenu.RadioItemIndicator.Props> {
  className?: string
}

function ContextMenuRadioItemIndicator({ className, children, ...props }: ContextMenuRadioItemIndicatorProps) {
  return (
    <BaseContextMenu.RadioItemIndicator
      data-slot="list-item-check"
      className={twMerge(listItemCheck, className)}
      {...props}
    >
      {children ?? <Check />}
    </BaseContextMenu.RadioItemIndicator>
  )
}

export { ContextMenuRadioItemIndicator }
